import addDays from "date-fns/addDays";
import { ALL_PLANS } from "./constants";

export const PAYMENT_FAILED_GRACE_DAYS = 30;

const toTimestamp = (value) => {
  if (value == null || value === "") return null;
  if (typeof value === "number") return Number.isNaN(value) ? null : value;
  if (value instanceof Date) {
    const ts = value.getTime();
    return Number.isNaN(ts) ? null : ts;
  }
  const ts = new Date(value).getTime();
  return Number.isNaN(ts) ? null : ts;
};

const getDueTime = (inv) => toTimestamp(inv?.dueDate) ?? 0;

/**
 * Resolve the payment-failure deadline: an explicit limit date, or due date plus grace days.
 * @returns {number|null}
 */
export const getPaymentFailedLimitDate = ({
  paymentFailedLimitDate,
  dueDate,
  graceDays = PAYMENT_FAILED_GRACE_DAYS,
} = {}) => {
  const explicitLimit = toTimestamp(paymentFailedLimitDate);
  if (explicitLimit != null) {
    return explicitLimit;
  }

  const dueTime = toTimestamp(dueDate);
  if (dueTime == null) {
    return null;
  }

  return addDays(new Date(dueTime), graceDays).getTime();
};

/**
 * Latest unpaid invoice whose subscription is a package plan (ALL_PLANS).
 * @param {Record<string, object>|null|undefined} payments
 * @returns {{ invoiceKey: string, invoiceData: object } | null}
 */
export const getLastPendingPackagePlanInvoiceEntry = (payments) => {
  if (!payments || typeof payments !== "object") return null;
  const unpaid = Object.entries(payments)
    .filter(
      ([, inv]) =>
        !inv?.isPaid &&
        inv?.subscription &&
        ALL_PLANS.includes(inv.subscription)
    )
    .sort(([, a], [, b]) => getDueTime(b) - getDueTime(a));
  if (unpaid.length === 0) return null;
  const [invoiceKey, invoiceData] = unpaid[0];
  return { invoiceKey, invoiceData };
};
